import classNames from 'classnames';
import OldTooltip, { placementsList } from '@picsart/rc/old/Tooltip';
import Tooltip from '@picsart/rc/Tooltip';
import { useTranslator } from '@picsart/rc/services/localization';

import CategoryButton from 'components/common/CategoryButton';

import useHistoryStyles from './styles';

interface IHistoryToolsButton {
  name: string;
  isInvertTool?: boolean;
  onClick: () => void;
  icon: React.ElementType;
  isLoading?: boolean;
  isDisabled?: boolean;
  isDarkMode: boolean;
}

const HistoryToolsButton = ({
  name,
  icon: Icon,
  onClick,
  isInvertTool = false,
  isLoading,
  isDisabled,
  isDarkMode,
}: IHistoryToolsButton) => {
  const classes = useHistoryStyles({
    isDarkMode,
  });
  const translate = useTranslator();

  const tooltipContent = (
    <div
      className={classNames(classes.container, {
        [classes.containerInvertHover]: isInvertTool && !isLoading,
        [classes.containerResetHover]: !isInvertTool && !isLoading,
        [classes.containerDisabledHover]: isLoading,
        [classes.containerDisabled]: isLoading || !isDisabled,
      })}
      onClick={onClick}
    >
      <Icon className={classes.historyToolIcons} />
      <p className={classNames(classes.toolIconName, 'we-reset-button')}>
        {translate(name)}
      </p>
    </div>
  );

  if (!isDarkMode) {
    return (
      <div className={classes.tooltipContainer}>
        <OldTooltip
          delayShow={1000}
          offset={[10, -10]}
          content={<p>{translate(name)}</p>}
          placement={placementsList.bottom}
        >
          {tooltipContent}
        </OldTooltip>
      </div>
    );
  }

  return (
    <div className={classes.tooltipContainer}>
      <div className={classNames(classes.sidebarTooltipItem, 'we-reset-button')}>
        <Tooltip
          enableArrow={false}
          mouseEnterDelay={1000}
          offset={[10, 15]}
          overlay={translate(name)}
          placement="bottom"
        >
          <span>
            <CategoryButton
              icon={Icon}
              isDisabled={isLoading || !isDisabled}
              textContent={translate(name)}
              tabIndex={0}
              onClick={onClick}
              isMultiLineTruncated
            />
          </span>
        </Tooltip>
      </div>
    </div>
  );
};

export default HistoryToolsButton;
